
define('text!modules/reporting/campaigns/templates/select_metric.html',[],function () { return '<select class="select-metric form-input">\n  {{#metrics}}\n  <option class="item" value="{{value}}" {{#selected}}selected="selected"{{/selected}}>{{text}}</option>\n  {{/metrics}}\n</select>\n';});

